import React from 'react'

import Cardprice from "../Components/Cards/Cardprice";
import TaxiComponent from "../Components/FillerComponents/Taxiservices";
import CarRentalSteps from "../Components/FillerComponents/taxione";
import DiscountInfo from "../Components/FillerComponents/taxitwo";

import { Button, Box, Typography } from "@mui/material";


const Selfdrive = () => {
 
  return (
    
    <div style={{marginTop:'20px'}}>
    <TaxiComponent />
    <Cardprice/>
   
    <CarRentalSteps/>
   
    <DiscountInfo/>
     

    </div>

  )
}

export default Selfdrive    